<template>
  <ul class="task-detail-dialog__check-list">
    <li
      v-for="node in renderedNodes"
      :key="node.ID"
      class="task-detail-dialog__check-item"
    >
      <div class="task-detail-dialog__check-row">
        <span
          :class="[
            'task-detail-dialog__check-state',
            node.IS_COMPLETE === 'Y'
              ? 'task-detail-dialog__check-state--done'
              : 'task-detail-dialog__check-state--todo',
          ]"
          :aria-label="node.IS_COMPLETE === 'Y' ? 'Выполнено' : 'Не выполнено'"
        >
          {{ node.IS_COMPLETE === 'Y' ? '✓' : '' }}
        </span>
        <div
          :class="[
            'task-detail-dialog__check-title',
            { 'task-detail-dialog__check-title--done': node.IS_COMPLETE === 'Y' },
          ]"
        >
          <span
            v-if="node.IS_IMPORTANT === 'Y'"
            class="task-detail-dialog__check-important"
          >
            !
          </span>
          {{ node.TITLE }}
        </div>
      </div>

      <task-check-list-tree
        v-if="Array.isArray(node.children) && node.children.length"
        :nodes="node.children"
      />
    </li>
  </ul>
</template>

<script>
export default {
  name: 'TaskCheckListTree',
  props: {
    checkList: {
      type: Array,
      default: null,
    },
    nodes: {
      type: Array,
      default: null,
    },
  },
  computed: {
    renderedNodes() {
      if (Array.isArray(this.nodes)) {
        return this.nodes
      }
      return this.toCheckListTree(this.checkList)
    },
  },
  methods: {
    toCheckListTree(checkList) {
      if (!Array.isArray(checkList) || !checkList.length) {
        return []
      }

      const groupedByParent = {}
      const normalizeNode = (item) => ({
        ...item,
        ID: String(item.ID),
        PARENT_ID: String(item.PARENT_ID ?? '0'),
        SORT_INDEX: Number(item.SORT_INDEX ?? 0),
      })
      const compareNodes = (a, b) => {
        if (a.SORT_INDEX !== b.SORT_INDEX) {
          return a.SORT_INDEX - b.SORT_INDEX
        }
        return Number(a.ID) - Number(b.ID)
      }
      const build = (parentId = '0') => {
        const items = groupedByParent[parentId] || []
        return [...items]
          .sort(compareNodes)
          .map(node => ({
            ...node,
            children: build(node.ID),
          }))
      }

      checkList.forEach(item => {
        const node = normalizeNode(item)
        const parentId = node.PARENT_ID
        if (!groupedByParent[parentId]) {
          groupedByParent[parentId] = []
        }
        groupedByParent[parentId].push(node)
      })

      return build('0')
    },
  },
}
</script>

<style scoped lang="scss">
.task-detail-dialog__check-list {
  margin: 0;
  padding: 0 0 0 16px;
  list-style: none;
  border-left: 1px solid #e2e8f0;
  font-size: 14px;
}

.task-detail-dialog__check-item {
  margin: 9px 0;
}

.task-detail-dialog__check-row {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.task-detail-dialog__check-state {
  width: 16px;
  height: 16px;
  flex: 0 0 16px;
  margin-top: 2px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
}

.task-detail-dialog__check-state--done {
  background: #16a34a;
  color: #fff;
  border: 1px solid #16a34a;
}

.task-detail-dialog__check-state--todo {
  background: #fff;
  border: 1px solid #94a3b8;
}

.task-detail-dialog__check-title {
  color: #0f172a;
}

.task-detail-dialog__check-title--done {
  text-decoration: line-through;
  color: #64748b;
}

.task-detail-dialog__check-important {
  display: inline-block;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #fee2e2;
  color: #b91c1c;
  font-size: 11px;
  text-align: center;
  line-height: 16px;
  margin-right: 6px;
  font-weight: 700;
}
</style>
